<template>
  <div class="container is-boxed-fluid section touch-scroll">
    <h2 class="section-title centered with-line">
      <span>
        {{title}}
      </span>
    </h2>
    <div class="items-slide">
      <mq-layout :mq="['md', 'lg', 'xl', 'hd', 'inf']">
        <swiper :options="swiperOption" ref="mySwiper">
          <!-- slides -->
          <swiper-slide v-for="(item, key) in items" :key="key">
            <component :is="component" :item="item"></component>
          </swiper-slide>
          <!-- Optional controls -->
        </swiper>

        <div class="swiper-prev" slot="button-prev"></div>
        <div class="swiper-next" slot="button-next"></div>
      </mq-layout>
      <mq-layout :mq="['xs', 'sm', 'ms']">
        <div class="mobile-scroll-slide">
          <component v-for="(item, key) in items" :key="key" :is="component" :item="item"></component>
        </div>
      </mq-layout>
    </div>
  </div>
</template>

<script>
import Product from '@/components/items/Product.vue';
import Category from '@/components/items/Category.vue';
import Job from '@/components/items/Job.vue';
import Instagram from '@/components/items/Instagram.vue';
export default {
  components: {
    Product,
    Category,
    Job,
    Instagram,
  },
  props: ['component', 'items', 'title', 'badge', 'slide_count'],
  data () {
    return {
      swiperOption: {
        slidesPerView: screen.width < 768 ? 1 : this.slide_count,
        spaceBetween: 30,
        centeredSlides: false,
        navigation: {
          nextEl: '.swiper-next',
          prevEl: '.swiper-prev'
        }
      }
    }
  }
}
</script>

<style lang="scss">
  .mobile-scroll-slide{
    display: flex;
    width: 100%;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    padding-left: 15px;
    &>.loop-item{
      width: 280px;
      flex: 0 0 auto;
      padding-right: 15px;
    }
  }
</style>
